/**
 * This enum represents the sorting direction in a query.
 */
/* eslint-disable-next-line no-shadow */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
